var render = function render(_c,_vm){return _c(_vm.$options.methods.getComponent(_vm.props.field, _vm.parent.$registry),_vm._g(_vm._b({tag:"component",staticClass:"active",attrs:{"read-only":true}},'component',_vm.data.attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }